export default {
  parameters: {
    landing_id: "UrAu1",
  },
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    startBackground: "#0A1A27",
    quizBackground: "#white",
    title: '<p><font color="FFFFFF"><b>¡Inscribe a tu hijo/a en una clase gratuita para aprender a diseñar y programar juegos con Roblox en 60 minutos!</font></b></p>',
    image: {
      url:  "/welcome/quiz_latam_roblox_custom_pk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/quiz_latam_roblox_custom_mobile.png",
      style: {
        width: "100%",
      },
    },
     button: {
      text: " Comenzar🚀 ",
      style: {
        background: "#FFFFFF",
        color: "#000000",
        "font-weight": "bold",
      },
    },
  },
  successPage: {
    title: "¡Felicitaciones! 🎁",
    subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
    button: "📆 Reservar una clase",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "¡Gracias por confiar en nuestra plataforma educativa! Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras aulas la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question: "¿Con qué frecuencia tu hijo/a juega a Roblox?",
      answers: [
          "🤔 Algunas horas al día",
          "👾 Sólo los fines de semana",
          "📱 Una o dos horas entre semana, pero más los fines de semana",
          "🙌 Sólo en ocasiones especiales",
          "⛔️ No juega"
       ],
    },
    2: {
      question: "¿Tu hijo/a tiene un ordenador en el que juega a Roblox?",
      answers: [
        "👍 Sí",
        "👎 No",
      ],
    },
    3: {
      question:
        "¿Qué le gustaría que ganara tu hijo/a asistiendo a una clase gratuita de Roblox?",
      answers: [
        "🖥 Iniciarse en la plataforma",
        "💭 Desarrollar su pensamiento crítico y sus habilidades de trabajo en equipo",
        "🧑‍💻 Aprenderá los fundamentos del diseño y la programación de juegos",
        "👾 Creará su propio juego",
        "❓ Aún no lo sé"
      ],
    },
    4: {
      question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true
        },
      ],
    },
  },
};


